import { HoverCardWithLink } from '@/components/hover-card-with-link';
import { NucleusVaultMetadata } from '@/constants/nucleus-vaults';
import { useApps } from '@/hooks/useApps';
import { capitalizeFirstLetter, getIconPathFromAppId, getIconPathFromTokenSymbol } from '@/utils';
import { Box, Card, Heading, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';

export const Composition = ({ vaultMetadata }: { vaultMetadata: NucleusVaultMetadata }) => {
  const { primaryComposition, relatedApps } = vaultMetadata;
  const { apps } = useApps();
  const mainApp = apps.find(({ id }) => id === primaryComposition.appId);
  return (
    <Box>
      <Heading size="2xl" fontWeight="700" mb={4}>
        Composition
      </Heading>
      <VStack w="full" gap={6} alignItems="stretch">
        <HoverCardWithLink href={mainApp?.website ?? ''}>
          <Card.Body>
            <Stack direction={['column', 'column', 'row']} justifyContent="space-between">
              <VStack gap={4} w="full" alignItems="start">
                <Stack direction={['column', 'column', 'row']} gap={4}>
                  <Image src={getIconPathFromTokenSymbol(primaryComposition.token)} boxSize={12} />
                  <Box>
                    <Heading size="xl" fontWeight="500" mb={1}>
                      {primaryComposition.token}
                    </Heading>
                    <Text fontSize="sm" fontWeight="500" color="fg.muted">
                      {primaryComposition.subTitle}
                    </Text>
                  </Box>
                </Stack>
                <Text fontSize="md" fontWeight="500" color="fg.muted">
                  {primaryComposition.description}
                </Text>
              </VStack>
              <Image h={90} src={primaryComposition.logosPath} />
            </Stack>
          </Card.Body>
        </HoverCardWithLink>
        <HStack gap={6} w="full">
          {relatedApps.map((app) => {
            const href = apps.find(({ id }) => id === app.appId)?.website;
            return (
              <HoverCardWithLink href={href} linkProps={{ flex: 1 }} key={app.appId}>
                <Card.Body>
                  <Image src={getIconPathFromAppId(app.appId)} boxSize={12} borderRadius="full" mb={4} />
                  <Heading fontSize="xl" fontWeight="500">
                    {capitalizeFirstLetter(app.appId)}
                  </Heading>
                  <Text fontSize="sm" color="fg.muted" fontWeight="500">
                    {app.subTitle}
                  </Text>
                </Card.Body>
              </HoverCardWithLink>
            );
          })}
        </HStack>
      </VStack>
    </Box>
  );
};
